import { API_URL } from "config";
import Notify from "config/notify";
import Http from "util/https";

/**
 * アップロードしたCSVを反映
 * @param process_id プロセスID
 */
export default async function uploadOrderSupplierCsv(process_id: string) {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/shipping/csv/regist`;
  const res = await http.post(url, { process_id });
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res = {status: 200};
  // if (res.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "発注しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
}
